import { Component, OnInit} from '@angular/core';
import { ClientService } from 'src/app/services/client.service';
import {PageEvent} from '@angular/material/paginator';
import {Sort} from '@angular/material/sort';
import {ClientOverviewDTO} from '../../../../model/clientOverviewDTO';
import {PaymentService} from '../../../../services/payment-service';
import {NotificationService} from '../../../../services/notification.service';

const informGiftCreated = {header: 'gift is aangemaakt', body: 'vergeet niet in de database het jaar aan te passen (staat op 9999)'};

@Component({
  templateUrl: './client-overview.component.html',
})
export class ClientOverviewComponent implements OnInit {

  content: ClientOverviewDTO[] = [];
  totalElements = 0;
  sort;

  pageSize = 1000;
  pageSizeOptions: number[] = [25, 50, 100, 250, 500, 1000];
  pageEvent: PageEvent = new PageEvent(); // MatPaginator Output

  constructor(private service: ClientService,
              private paymentService: PaymentService,
              private notificationService: NotificationService) {}

  ngOnInit() {
    this.sort = {column: 'id', dir: 'desc'};
    this.pageEvent.pageIndex = 0;
    this.pageEvent.pageSize = this.pageSize;
    this.getPage();
  }

  updatePage($event) {
    this.pageEvent = $event;
    this.getPage();
    return $event;
  }

  getPage() {
    this.service.getOverview(this.pageEvent.pageIndex, this.pageEvent.pageSize, this.sort.column, this.sort.dir).subscribe(page => {
      this.content = page.content;
      this.totalElements = page.totalElements;
    });
  }

  sortPage($event: Sort) {
    this.sort.column = $event.active;
    this.sort.dir = $event.direction;
    this.getPage();
  }

  gift(client: ClientOverviewDTO, event: MouseEvent) {
    event.stopPropagation();
    this.notificationService.confirm({body: 'er word een gift aangemaakt voor het jaar 9999'}).then(() => {
      this.paymentService.gift(client.id, 9999).subscribe(
        () => this.notificationService.inform(informGiftCreated),
        (response) => this.notificationService.errorResponse(response)
      );
    });
  }
}
